// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"styles_tableRow__3PT23","boldText":"styles_boldText__1BdbV","textUppercase":"styles_textUppercase__3YBEr","download":"styles_download__L2DET"};